'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowLeftTwoRectangles, iconArrowLeftTwoRectanglesTag } from '@ni/nimble-components/dist/esm/icons/arrow-left-two-rectangles';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowLeftTwoRectangles };
export { iconArrowLeftTwoRectanglesTag };
export const NimbleIconArrowLeftTwoRectangles = wrap(IconArrowLeftTwoRectangles);